import { render, staticRenderFns } from "./locationAndClasstypeAndCoursepackage.vue?vue&type=template&id=8dc181e0&scoped=true&"
import script from "./locationAndClasstypeAndCoursepackage.vue?vue&type=script&lang=js&"
export * from "./locationAndClasstypeAndCoursepackage.vue?vue&type=script&lang=js&"
import style0 from "./locationAndClasstypeAndCoursepackage.vue?vue&type=style&index=0&id=8dc181e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc181e0",
  null
  
)

export default component.exports